<template>
  <div class="text-center bg-grey">
    <v-tabs
      v-model="tab"
      centered
      icons-and-text
      :optional="flag"
      class="d-flex justify-center"
    >
      <v-tab
        href="#suspend"
        v-if="
          updateDirectoryUserDetails.status == 'active' &&
          updateDirectoryUserDetails.status != 'inactive'
        "
      >
        <v-btn class="ma-1" outlined color="grey"> Suspend </v-btn>
      </v-tab>
      <v-tab
        href="#unsuspend"
        v-if="
          updateDirectoryUserDetails.status != 'active' &&
          updateDirectoryUserDetails.status != 'inactive'
        "
      >
        <v-btn class="ma-1" outlined color="grey"> Unsuspend </v-btn>
      </v-tab>
      <v-tab
        href="#remove"
        v-if="
          updateDirectoryUserDetails.status != 'active' &&
          updateDirectoryUserDetails.status != 'inactive'
        "
      >
        <v-btn class="ma-1" outlined color="grey"> Remove </v-btn>
      </v-tab>
      <v-tab href="#specifyPassword">
        <v-btn class="ma-1" outlined color="grey"> Specify Password </v-btn>
      </v-tab>

      <v-tab href="#passwordReset" @click.prevent="generateNewPwd()">
        <v-btn class="ma-1" outlined color="grey"> Password Reset </v-btn>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="bg-transparent">
      <v-tab-item
        value="suspend"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <div class="update-form pa-8 mx-auto" style="width: 60%">
          <h6 class="font-weight-bold pb-4 text-left">
            Suspend
            <span
              class="float-right font-weight-medium"
              @click="closeUpdateTab"
            >
              <v-icon>mdi-close-circle</v-icon>
            </span>
          </h6>
          <div class="py-2">
            <h4 class="pb-2 grey--text text-left">
              Are you sure you'd like to suspend now?*
            </h4>
            <v-textarea
              v-model="suspendPersonReason"
              outlined
              dense
            ></v-textarea>
          </div>
          <div class="mt-2 text-right">
            <v-btn depressed medium class="mr-1" @click="closeUpdateTab">
              Cancel
            </v-btn>
            <v-btn
              depressed
              medium
              color="rgb(0, 102, 124)"
              class="white--text"
              @click="suspendPerson"
            >
              Update
            </v-btn>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item
        value="unsuspend"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <div class="update-form pa-8 mx-auto" style="width: 60%">
          <h6 class="font-weight-bold pb-4 text-left">
            Unsuspend
            <span
              class="float-right font-weight-medium"
              @click="closeUpdateTab"
            >
              <v-icon>mdi-close-circle</v-icon>
            </span>
          </h6>
          <div class="py-2">
            <h4 class="pb-2 grey--text text-left">
              Are you sure you'd like to unsuspend now?
            </h4>
            <v-textarea outlined dense></v-textarea>
          </div>
          <div class="mt-2 text-right">
            <v-btn depressed medium class="mr-1" @click="closeUpdateTab">
              Cancel
            </v-btn>
            <v-btn
              depressed
              medium
              color="rgb(0, 102, 124)"
              class="white--text"
              @click="unsuspendPerson"
            >
              Update
            </v-btn>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item
        value="remove"
        transition="fade-transition"
        reverse-transition="fade-transition"
      >
        <div class="update-form pa-8 mx-auto" style="width: 60%">
          <h6 class="font-weight-bold pb-4 text-left">
            Remove
            <span
              class="float-right font-weight-medium"
              @click="closeUpdateTab"
            >
              <v-icon>mdi-close-circle</v-icon>
            </span>
          </h6>
          <div class="py-2">
            <h4 class="pb-2 grey--text text-left">
              Are you sure you'd like to remove now?*
            </h4>
            <v-textarea outlined dense></v-textarea>
          </div>
          <div class="mt-2 text-right">
            <v-btn depressed medium class="mr-1" @click="closeUpdateTab">
              Cancel
            </v-btn>
            <v-btn
              depressed
              medium
              color="rgb(0, 102, 124)"
              class="white--text"
              @click="removePersonPerson"
            >
              Update
            </v-btn>
          </div>
        </div>
      </v-tab-item>
      <v-tab-item value="specifyPassword">
        <div class="update-form pa-8 mx-auto pwd-form" style="width: 60%">
          <h6 class="font-weight-bold pb-4 text-left">
            Specify password
            <span
              class="float-right font-weight-medium"
              @click="closeUpdateTab"
            >
              <v-icon>mdi-close-circle</v-icon>
            </span>
          </h6>
          <v-form ref="form" v-model="valid">
            <div class="py-2">
              <h4 class="pb-2 grey--text text-left">Enter new password</h4>
              <v-text-field
                v-model="pw1"
                outlined
                dense
                type="password"
                autocomplete="off"
                :rules="pwdRules"
                :class="validationRes.valid == false ? 'error--text validatepwd' : 'validatepwd'"
              ></v-text-field>
              <p v-if="(validationRes.errors.length > 0) || (validationRes.valid == false)" class="error--text error-msg">{{messageValidationerror}}</p>
            </div>
            <div class="py-2">
              <h4 class="pb-2 grey--text text-left">Re-enter new password</h4>
              <v-text-field
                v-model="pw2"
                outlined
                dense
                type="password"
                :rules="pwdConfirm"
              ></v-text-field>
            </div>
            <div class="mt-2 text-right">
              <v-btn depressed medium class="mr-1" @click="closeUpdateTab">
                Cancel
              </v-btn>
              <v-btn
                depressed
                medium
                color="rgb(0, 102, 124)"
                class="white--text"
                @click="updatePassword()"
                :disabled="(!valid || !validationRes.valid) ? true : false"
              >
                Update
              </v-btn>
            </div>
          </v-form>
        </div>
      </v-tab-item>
      <v-tab-item value="passwordReset">
        <div class="update-form pa-8 mx-auto" style="width: 60%">
          <h6 class="font-weight-bold pb-4 text-left">
            Password Reset
            <span
              class="float-right font-weight-medium"
              @click="closeUpdateTab"
            >
              <v-icon>mdi-close-circle</v-icon>
            </span>
          </h6>
          <p class="font-weight-bold text-left pt-3 pb-2">
            Password Reset is successful. New password is:
            <span>{{ newPwd }}</span>
          </p>
          <p class="font-weight-bold text-left pb-3">
            Note: if you are seeing only first half password then the second
            half password will be sent to users registered email.
          </p>
        </div>
      </v-tab-item>
    </v-tabs-items>
    <v-snackbar
      :timeout="5000"
      :value="directoryFlag"
      color="rgb(0, 102, 124)"
      absolute
      top
    >
      {{ notify }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable */
// eslint-disable-next-line
export default {
  props: {
    personID: String,
  },
  beforeMount() {
    this.$store.commit("SET_DIRECTOY_FLAG", false);
  },
  data() {
    return {
      tab: null,
      flag: true,
      valid: true,
      currentPwd: "",
      pw1: "",
      pw2: "",
      pwdConfirm: [
        (v) => !!v || "Confirm password",
        (v) => v === this.pw1 || "Passwords do not match",
      ],
      suspendPersonReason: null,
      notify: null,
      rules: [],
      requiredNumberOfCharClasses: 1,
      messageValidationerror: null,
      minLength: 8,
      validationRes: { valid:true, errors:[] },
      lengthCondition: {}
    };
  },
  watch: {
    newPwd(val) {
      if (val != "") {
        this.tab = "passwordReset";
      }
    },
    directoryFlag(val) {
      if (val == true) {
        setTimeout(function () {
          this.$store.commit("SET_DIRECTOY_FLAG", false);
        }, 1000);
      }
    },
    pw1(val) {
      let errors = []
			for (let condition of this.rules) {
				if (!condition.regex.test(val)) {
					errors.push(condition.message)
				}
			}
			if ((this.rules.length - errors.length ) >= this.requiredNumberOfCharClasses) {
				this.validationRes = { valid:true, errors:[] }
			} else {
				this.validationRes = { valid:false, errors }
			}
    },
  },
  computed: {
    updateDirectoryUserDetails() {
      return this.$store.getters.getDetailsPerson;
    },
    directoryFlag() {
      return this.$store.getters.getDirectoryFlag;
    },
    newPwd() {
      return this.$store.getters.getNewPwd;
    },
      passwordRules () {
        return this.$store.getters.getPwdRules
      },
    pwdRules() {
      if (this.$store.getters.getPwdRules.length > 0) {
        this.rules = [];
        const passwordRulesList = this.$store.getters.getPwdRules[0];
        const passwordLength = this.$store.getters.getPwdRules[1].min;
        this.requiredNumberOfCharClasses = passwordRulesList.requiredNumberOfCharClasses;
        this.minLength = this.$store.getters.getPwdRules[1].min;

        if(passwordRulesList.allowUpperChars) {
          this.rules.push({ message:"One uppercase letter required.",  regex:/[A-Z]+/ })
        }
         if(passwordRulesList.allowLowerChars) {
          this.rules.push({ message:'One lowercase letter required.', regex:/[a-z]+/ })
        }
        if(passwordRulesList.allowNumChars) {
          this.rules.push({ message:"One number required.", regex:/[0-9]+/ })
        }
        if(passwordRulesList.allowSpecialChars) {
          this.rules.push({ message:"secial characters minimum.", regex:/[!#$%&'*+/=@]+/ })
        }
        if (
          passwordRulesList.allowUpperChars &&
          passwordRulesList.allowLowerChars &&
          passwordRulesList.allowNumChars &&
          passwordRulesList.allowSpecialChars
        ) {
          this.messageValidationerror = `The password must contain atleast ${this.requiredNumberOfCharClasses} of the following character types: Number, Lower Case Letters, Upper Case Letters, special symbol(ex: !,*,+)`
          
          } else if (
          passwordRulesList.allowUpperChars &&
          passwordRulesList.allowLowerChars &&
          passwordRulesList.allowNumChars &&
          !passwordRulesList.allowSpecialChars
        ) {
          this.messageValidationerror = `The password must contain atleast ${this.requiredNumberOfCharClasses} of the following character types: Number, Lower Case Letters, Upper Case Letters`
          
        } else {
          this.messageValidationerror = `The password must contain atleast ${this.requiredNumberOfCharClasses} of the following character types: Lower Case Letters, Upper Case Letters`;
         
        }
        return [
          v => (v && v.length >= this.minLength) || `Password must be greater than ${passwordLength} characters.`
        ]
      }else {
        return []
      }
    },
  },
  methods: {
    closeUpdateTab() {
      this.tab = null;
      this.validationRes= { valid:true, errors:[] };
    },
    suspendPerson() {
      this.notify = "Suspended successfully";
      this.$store.dispatch("suspendPerson", [
        ["personId", this.personID],
        ["reason", this.suspendPersonReason],
      ]);
      this.closeUpdateTab();
    },
    unsuspendPerson() {
      this.notify = "Unsuspend successfully";
      this.$store.dispatch("unsuspendPerson", [
        ["personId", this.personID],
        ["reason", this.suspendPersonReason],
      ]);
      this.closeUpdateTab();
    },
    removePersonPerson() {
      this.notify = "Removed successfully";
      this.$store.dispatch("removePerson", {
        personId: this.personID,
        reason: [["reason", this.suspendPersonReason]],
      });
      this.closeUpdateTab();
    },
    updatePassword() {
      this.notify = "Password Updated successfully";
      this.$store.dispatch("getPersonPassword", {
        subject: this.personID,
        password: this.pw1,
      });
      this.pw1 = "";
      this.pw2 = "";
      this.closeUpdateTab();
    },
    generateNewPwd() {
      this.$store.dispatch("resetPersonPassword", this.personID);
    },
  },
};
</script>
<style>
.validatepwd .v-messages__message {
  border: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/partials/directoryTabs.vue